import React from 'react';

import Form from '~/components/MedicalEvent/Form';

import ReferenceDataProvider from '~/utils/reference-data/context';

const MedicalEvents = () => (
  <ReferenceDataProvider
    type="ReferenceMedicalEvent"
    config={{
      customFields: {
        propertyRules: {
          initialValue: {},
          normalizeValue: v => (v ? JSON.parse(v) : {}),
          serializeValue: v => (v ? JSON.stringify(v) : null),
          component: Form,
        },
      },
    }}
  />
);

export default MedicalEvents;
